<form class="sdp-saml-wizard-form" [formGroup]="form" novalidate>
	<div class="sdp-clear"></div>
	<div>
		<div class="sdp-form-control">
			<mat-form-field class="sdp-form-control-input-container">
				<input matInput placeholder="{{ 'applications.label.ip' | translate }}" type="text"
					formControlName="ip">
				<mat-error
					*ngIf="form.controls['ip'].hasError('invalidDomainOrIp') || form.controls['ip'].hasError('required')">
					{{ "error.form.ipdomain" | translate }}.</mat-error>
			</mat-form-field>
			<div>
				<p>{{ "applications.label.example" | translate }}</p>
				<ul>
					<li>1.1.1.1</li>
					<li>1.1.1.1 - 1.1.2.255</li>
					<li>1.1.1.0/24</li>
					<li>example.com</li>
				</ul>
			</div>
		</div>
	</div>
</form>